import { useMemo } from "react";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  root: `Card`,
  content: `CardContent`,
  column: `CardColumn`,
  header: `CardHeader`,
  action: `CardAction`
};

export function useCardStyles(externalStyleSet: IStyleSet) {
  const { effects, semanticColors } = useTheme();
  const styleSet = useMemo(
    () => mergeStyleSets(
      {
        root: [
          classNames.root,
          {
            backgroundColor: semanticColors.bodyStandoutBackground,
            borderRadius: effects.roundedCorner4,
            boxShadow: effects.elevation4,
            margin: 10,
            minHeight: `150px`,
            minWidth: `250px`,
            overflow: `auto`,
            padding: 15,
            position: `relative`
          }
        ],
        content: [
          classNames.content,
          {
            overflow: `hidden`
          }
        ],
        column: [
          classNames.column,
          {
            "& > :first-child": {
              position: `relative`,
              "&:nth-last-child(2)": {
                marginRight: 0
              }
            },
            "& hr": {
              border: `none`,
              borderLeft: `2px solid ${semanticColors.bodyDivider}`,
              height: `180px`,
              marginBottom: 0,
              marginTop: `-5px`
            },
            "&:last-child hr": {
              display: `none`
            }
          }
        ],
        header: [
          classNames.header,
          {
            fontWeight: `600`,
            fontSize: `1.2em`,
            marginBottom: `15px`
          }
        ],
        action: [
          classNames.action,
          {
            position: `absolute`,
            bottom: `5px`,
            right: `5px`
          }
        ]
      },
      externalStyleSet
    ),
    [effects, semanticColors, externalStyleSet]
  );

  return styleSet;
}
